const endpoints = {
	fileUploadToReport: '/files/fileUploadToReport',
}
export {endpoints}